/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react/macro'
import colors from '@sportninja/common/constants/appColors'
import { useEffect, useState } from 'react'
import { Flex } from '../Layout'
import Icon from '../Icon'
import { captionXSmall, paragraphSmall, weightRegular } from '../css'

const CopyComponent = ({
  id,
  customText = 'ID',
  alternativeBackground = false,
}) => {
  const [hasCopied, setHasCopied] = useState(false)

  useEffect(() => {
    if (hasCopied) {
      setTimeout(() => {
        setHasCopied(false)
      }, 2000)
    }
  }, [hasCopied])

  return (
    <Flex>
      <Flex alignItems='center' noFlex>
        <Flex
          justifyContent='center'
          alignItems='center'
          css={css`
            border-radius: 8px;
            background-color: ${!alternativeBackground
              ? '#1B222B'
              : colors.SECONDARY_300};
            margin-left: 8px;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: ${alternativeBackground ? 8 : 4}px;
            padding-bottom: ${alternativeBackground ? 8 : 4}px;
          `}
        >
          <span
            css={css`
              ${paragraphSmall}
              ${weightRegular}
              color: ${colors.NEUTRAL_100};
            `}
          >
            {customText}
          </span>
          <div
            css={css`
              ${captionXSmall}
              ${weightRegular}
              color: ${colors.WHITE};
              margin-left: 8px;
              margin-right: 8px;
            `}
          >
            {hasCopied ? 'Copied' : id}
          </div>
          <button
            type='button'
            title='Copy UID to clipboard'
            onClick={() => {
              navigator.clipboard.writeText(id)
              setHasCopied(true)
            }}
            css={css`
              height: 100%;
            `}
          >
            <Icon
              faType='far'
              name={hasCopied ? 'clipboard-check' : 'clipboard'}
              color={hasCopied ? colors.DEFAULT_FLAIR : undefined}
              fontSize={16}
            />
          </button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CopyComponent
